module.exports = __webpack_public_path__ + "img/icon-live-tv.f3423bf5.svg";